import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const positionTooltip = ({ elem, elemPlacement, overlay, offset = 8 }) => {
    if (elem == undefined)
        return;
    const rect = elem.getBoundingClientRect();
    const contentRect = overlay.getBoundingClientRect();
    // Exit the function if the placement is not set
    if (!elemPlacement || elemPlacement == "")
        return;
    switch (true) {
        case elemPlacement.includes("right"):
            overlay.style.top = '50%';
            overlay.style.left = `calc(${rect.width}px + ${offset}px)`;
            overlay.style.transform = 'translateY(-50%)';
            if (elemPlacement.includes("start")) {
                overlay.style.top = '0';
                overlay.style.transform = 'translateY(0)';
            }
            if (elemPlacement.includes("end")) {
                overlay.style.bottom = '0';
                overlay.style.top = 'initial';
                overlay.style.transform = 'translateY(0)';
            }
            break;
        case elemPlacement.includes("left"):
            overlay.style.top = '50%';
            overlay.style.right = `calc(${rect.width}px + ${offset}px)`;
            overlay.style.transform = 'translateY(-50%)';
            if (elemPlacement.includes("start")) {
                overlay.style.top = '0';
                overlay.style.transform = 'translateY(0)';
            }
            if (elemPlacement.includes("end")) {
                overlay.style.bottom = '0';
                overlay.style.top = 'initial';
                overlay.style.transform = 'translateY(0)';
            }
            break;
        case elemPlacement.includes("bottom"):
            overlay.style.top = `calc(${rect.height}px + ${offset}px)`;
            overlay.style.left = '50%';
            overlay.style.transform = 'translateX(-50%)';
            if (elemPlacement.includes("start")) {
                overlay.style.left = '0';
                overlay.style.transform = 'translateX(0)';
            }
            if (elemPlacement.includes("end")) {
                overlay.style.left = 'initial';
                overlay.style.right = '0';
                overlay.style.transform = 'translateX(0)';
            }
            break;
        case elemPlacement.includes("top"):
            overlay.style.top = `calc((${contentRect.height}px + ${offset}px) * -1)`;
            overlay.style.left = '50%';
            overlay.style.transform = 'translateX(-50%)';
            if (elemPlacement.includes("start")) {
                overlay.style.left = '0';
                overlay.style.transform = 'translateX(0)';
            }
            if (elemPlacement.includes("end")) {
                overlay.style.left = 'initial';
                overlay.style.right = '0';
                overlay.style.transform = 'translateX(0)';
            }
            break;
    }
};

const pdsTooltipCss = ":host{--tooltip-border-width-arrow-down:var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow) 0;--tooltip-border-width-arrow-left:var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow) 0;--tooltip-border-width-arrow-right:var(--tooltip-sizing-arrow) 0 var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow);--tooltip-border-width-arrow-up:0 var(--tooltip-sizing-arrow) var(--tooltip-sizing-arrow);--tooltip-sizing-arrow:6px;--tooltip-sizing-arrow-offset:14px;--tooltip-dimension-max-width:320px;display:inline-block;position:relative}:host ::slotted(*){display:-ms-flexbox;display:flex}:host ::slotted([slot=content]){display:block;max-width:var(--tooltip-dimension-max-width);white-space:normal}.pds-tooltip__content{background-color:var(--pine-color-primary);border-radius:calc(var(--pine-dimension-xs) * 1.25);-webkit-box-shadow:var(--pine-box-shadow);box-shadow:var(--pine-box-shadow);color:var(--pine-color-text-primary);max-width:var(--tooltip-dimension-max-width);opacity:0;padding:var(--pine-dimension-xs) calc(var(--pine-dimension-md) / 2);position:absolute;visibility:hidden;width:-webkit-max-content;width:-moz-max-content;width:max-content}.pds-tooltip--is-open .pds-tooltip__content{opacity:1;visibility:visible;z-index:1}:host(.pds-tooltip--has-html-content) .pds-tooltip__content{width:auto}.pds-tooltip__content::after{border-color:transparent;border-right-color:transparent;border-style:solid;border-width:var(--tooltip-border-width-arrow-left);content:\"\";height:0;position:absolute;width:0}.pds-tooltip--right .pds-tooltip__content::after{border-inline-end-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-left);left:calc(var(--tooltip-sizing-arrow) * -1);top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.pds-tooltip--right-end .pds-tooltip__content::after{border-inline-end-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-left);bottom:var(--tooltip-sizing-arrow-offset);left:calc(var(--tooltip-sizing-arrow) * -1);top:initial}.pds-tooltip--right-start .pds-tooltip__content::after{border-inline-end-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-left);left:calc(var(--tooltip-sizing-arrow) * -1);top:var(--tooltip-sizing-arrow-offset)}.pds-tooltip--top .pds-tooltip__content::after{border-block-start-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-down);bottom:calc(var(--tooltip-sizing-arrow) * -1);left:50%;top:initial;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.pds-tooltip--top-start .pds-tooltip__content::after{border-block-start-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-down);bottom:calc(var(--tooltip-sizing-arrow) * -1);left:var(--tooltip-sizing-arrow-offset);top:initial}.pds-tooltip--top-end .pds-tooltip__content::after{border-block-start-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-down);bottom:calc(var(--tooltip-sizing-arrow) * -1);left:initial;right:var(--tooltip-sizing-arrow-offset);top:initial}.pds-tooltip--left .pds-tooltip__content::after{border-inline-start-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-right);left:initial;right:calc(var(--tooltip-sizing-arrow) * -1);top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.pds-tooltip--left-end .pds-tooltip__content::after{border-inline-start-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-right);bottom:var(--tooltip-sizing-arrow-offset);left:initial;right:calc(var(--tooltip-sizing-arrow) * -1);top:initial}.pds-tooltip--left-start .pds-tooltip__content::after{border-inline-start-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-right);left:initial;right:calc(var(--tooltip-sizing-arrow) * -1);top:var(--tooltip-sizing-arrow-offset)}.pds-tooltip--bottom .pds-tooltip__content::after{border-block-end-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-up);left:50%;top:calc(var(--tooltip-sizing-arrow) * -1);-webkit-transform:translateX(-50%);transform:translateX(-50%)}.pds-tooltip--bottom-end .pds-tooltip__content::after{border-block-end-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-up);left:initial;right:var(--tooltip-sizing-arrow-offset);top:calc(var(--tooltip-sizing-arrow) * -1)}.pds-tooltip--bottom-start .pds-tooltip__content::after{border-block-end-color:var(--pine-color-primary);border-width:var(--tooltip-border-width-arrow-up);left:var(--tooltip-sizing-arrow-offset);top:calc(var(--tooltip-sizing-arrow) * -1)}.pds-tooltip--no-arrow .pds-tooltip__content::after{border-width:0}";

const PdsTooltip$1 = /*@__PURE__*/ proxyCustomElement(class PdsTooltip extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Determines when the tooltip is open
         * @defaultValue false
         */
        this.isOpen = false;
        /**
         * Determines whether or not the tooltip has an arrow
         * @defaultValue true
         */
        this.hasArrow = true;
        /**
         * Enable this option when using the content slot
         * @defaultValue false
         */
        this.htmlContent = false;
        /**
         * Determines the preferred position of the tooltip
         * @defaultValue "right"
         */
        this.placement = 'right';
        /**
         * Sets the maximum width of the tooltip content
         * @defaultValue "352px"
         */
        this.maxWidth = '352px';
        /**
         * Determines whether or not the tooltip is visible
         * @defaultValue false
         */
        this.opened = false;
        this.handleHide = () => {
            this.hideTooltip();
        };
        this.handleShow = () => {
            this.showTooltip();
        };
        this.handlePageShow = () => {
            this.opened = false;
        };
    }
    handleOpenToggle() {
        if (this.opened) {
            this.handleShow();
        }
        else {
            this.handleHide();
        }
    }
    componentWillLoad() {
        if (this.opened) {
            this.showTooltip();
        }
        this.el.addEventListener('blur', this.handleHide, true);
        this.el.addEventListener('focus', this.handleShow, true);
    }
    componentDidLoad() {
        // fix for Safari iOS back button issue
        window.addEventListener('pageshow', this.handlePageShow);
        return () => {
            window.removeEventListener('pageshow', this.handlePageShow);
        };
    }
    componentDidUpdate() {
        if (this.opened) {
            this.showTooltip();
        }
    }
    componentDidRender() {
        positionTooltip({ elem: this.el, elemPlacement: this.placement, overlay: this.contentEl });
    }
    /**
     * Shows the tooltip by enabling the opened property
     */
    async showTooltip() {
        this.opened = true;
    }
    /**
     * Hides the tooltip by disabling the opened property
     */
    async hideTooltip() {
        this.opened = false;
    }
    render() {
        return (h(Host, { key: '2732f2c81bc66814945206ddde15367e64a89ec2', onMouseEnter: this.handleShow, onMouseLeave: this.handleHide, onFocusin: this.handleShow, onFocusout: this.handleHide }, h("div", { key: '58705f1fbb1d88b91337100ba32de07f7838be52', class: `
            pds-tooltip
            pds-tooltip--${this.placement}
            ${this.htmlContent ? 'pds-tooltip--has-html-content' : ''}
            ${this.opened ? 'pds-tooltip--is-open' : ''}
            ${this.hasArrow ? '' : 'pds-tooltip--no-arrow'}
          ` }, h("span", { key: '33e96cb4f46ebc418f79971047a37fc5c3498e0d', "aria-describedby": this.componentId, class: "pds-tooltip__trigger" }, h("slot", { key: 'cca7b5d50e2cbc0f839a46caa5a5dc8a79f1cb15' })), h("div", { key: '22c666894f7835629e00e9c2c3964bcaf63000ae', class: "pds-tooltip__content", "aria-hidden": this.opened ? 'false' : 'true', "aria-live": this.opened ? 'polite' : 'off', id: this.componentId, ref: (el) => (this.contentEl = el), role: "tooltip", style: { maxWidth: this.maxWidth } }, h("slot", { key: '83a805d9eef71ac261a03d56853ccc8ac7bfe818', name: "content" }), this.content))));
    }
    get el() { return this; }
    static get watchers() { return {
        "opened": ["handleOpenToggle"]
    }; }
    static get style() { return pdsTooltipCss; }
}, [1, "pds-tooltip", {
        "content": [1],
        "componentId": [1, "component-id"],
        "hasArrow": [4, "has-arrow"],
        "htmlContent": [4, "html-content"],
        "placement": [513],
        "maxWidth": [1, "max-width"],
        "opened": [1540],
        "isOpen": [32],
        "showTooltip": [64],
        "hideTooltip": [64]
    }, undefined, {
        "opened": ["handleOpenToggle"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-tooltip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsTooltip$1);
            }
            break;
    } });
}

const PdsTooltip = PdsTooltip$1;
const defineCustomElement = defineCustomElement$1;

export { PdsTooltip, defineCustomElement };
//# sourceMappingURL=pds-tooltip.js.map

//# sourceMappingURL=pds-tooltip.js.map